import axios from "axios";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

import { userLogout } from "./user";
import { clearCheckout } from "./checkout";
import { updateCart } from "./cart";

// ===================================================================================
//  GET
// ===================================================================================
export const shippingPaymentOptionsLoading = () => {
	return {
		type: "SHIPPING_PAYMENT_OPTIONS_LOADING"
	};
};

export const shippingOptionsError = err => {
	return {
		type: "SHIPPING_PAYMENT_OPTIONS_ERROR",
		err
	};
};

export const shippingOptionsSuccess = data => {
	return {
		type: "SHIPPING_PAYMENT_OPTIONS_SUCCESS",
		data
	};
};

export function getShippingPaymentOptions() {
	return (dispatch, getState) => {
		dispatch(shippingPaymentOptionsLoading());

		// Set user token (account/guest)
		let token = "";
		if (getState().user.customer) token = getState().user.customer.token;
		else if (getState().user.guest) token = getState().user.guest.token;

		let AUTH_HEADER = {
			Authorization: REACT_APP_SITE_KEY + ":Bearer " + token
		};

		// Put data together to send
		let orderData = {};
		orderData.cart = getState().cart.shoppertrack;
		orderData.shipping = getState().checkout.shipping;

		return axios
			.post(REACT_APP_API_URL + "shipping-payment-options", orderData, {
				headers: AUTH_HEADER
			})
			.then(response => {
				if (!!response.data.status && response.data.status !== 200) {
					// Log user out if token expired, token, etc
					if (response.data.status === 403) {
						dispatch(clearCheckout());
						dispatch(userLogout(!!getState().user.customer ? "customer" : "guest"));
					}

					if (!!response.data.errors.general) {
						dispatch(shippingOptionsError(response.data.errors));
					} else {
						dispatch(shippingOptionsError({ general: response.data.message }));
					}
				}
				// Success
				else {
					// FLAT SHIPPING OVERRIDE
					let price = 15.00;
					let name = "Flat Shipping";
					
					// Check if backend determined it's free shipping
					if (response.data.options && response.data.options.length > 0 && response.data.options[0].price == 0) {
						price = 0;
						name = response.data.options[0].name;
					}

					response.data.options = [
						{ name: name, price: price }
					];

					dispatch(shippingOptionsSuccess(response.data));
					return Promise.resolve(response.data);
				}
			})
			.catch(err => {
				console.log("getShippingPaymentOptions error:", err.response.statusText);
				dispatch(shippingOptionsError({ general: err.response.statusText }));
			});
	};
}

// ===================================================================================
//  SET
// ===================================================================================
export const shippingPaymentSelectionLoading = () => {
	return {
		type: "SHIPPING_PAYMENT_SELECTION_LOADING"
	};
};

export const shippingOptionSelectionError = err => {
	return {
		type: "SHIPPING_PAYMENT_SELECTION_ERROR",
		err
	};
};

export const shippingOptionSelectionSuccess = data => {
	return {
		type: "SHIPPING_PAYMENT_SELECTION_SUCCESS",
		data
	};
};

export function setShippingPaymentOption(selection) {
	return (dispatch, getState) => {
		dispatch(shippingPaymentSelectionLoading());

		// Set user token (account/guest)
		let token = "";
		if (getState().user.customer) token = getState().user.customer.token;
		else if (getState().user.guest) token = getState().user.guest.token;

		let AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

		// Put data together to send
		let orderData = {};
		orderData.cart = getState().cart.shoppertrack;
		orderData.shipping = getState().checkout.shipping;
		orderData.selection = selection;

		return axios
			.post(REACT_APP_API_URL + "shipping-payment-options/set", orderData, {
				headers: AUTH_HEADER
			})
			.then(response => {
				if (!!response.data.status && response.data.status !== 200) {
					// Log user out if token expired, token, etc
					if (response.data.status === 403) {
						dispatch(clearCheckout());
						dispatch(userLogout(!!getState().user.customer ? "customer" : "guest"));
					}

					if (!!response.data.errors.general) {
						dispatch(shippingOptionSelectionError(response.data.errors));
					} else {
						dispatch(
							shippingOptionSelectionError({
								general: response.data.message
							})
						);
					}
				}
				// Success
				else {
					dispatch(shippingOptionSelectionSuccess(response.data));

					// Update cart data
					dispatch(updateCart(response.data));
				}
			})
			.catch(err => {
				console.log("setShippingPaymentOptions error:", err.response.statusText);
				dispatch(shippingOptionSelectionError({ general: err.response.statusText }));
			});
	};
}

export function clearShippingPaymentOption() {
	return (dispatch, getState) => {
		dispatch(shippingPaymentSelectionLoading());

		// Set user token (account/guest)
		let token = "";
		if (getState().user.customer) token = getState().user.customer.token;
		else if (getState().user.guest) token = getState().user.guest.token;

		let AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

		// Put data together to send
		let orderData = {};
		orderData.cart = getState().cart.shoppertrack;

		return axios
			.post(REACT_APP_API_URL + "shipping-payment-options/clear", orderData, {
				headers: AUTH_HEADER
			})
			.then(response => {
				if (!!response.data.status && response.data.status !== 200) {
					// Log user out if token expired, token, etc
					if (response.data.status === 403) {
						dispatch(clearCheckout());
						dispatch(userLogout(!!getState().user.customer ? "customer" : "guest"));
					}

					if (!!response.data.errors.general) {
						dispatch(shippingOptionSelectionError(response.data.errors));
					} else {
						dispatch(
							shippingOptionSelectionError({
								general: response.data.message
							})
						);
					}
				}
				// Success
				else {
					// dispatch(shippingOptionSelectionSuccess(response.data));

					// // Update cart data
					// dispatch(updateCart(response.data));
				}
			})
			.catch(err => {
				console.log("clearShippingPaymentOptions error:", err.response.statusText);
				dispatch(shippingOptionSelectionError({ general: err.response.statusText }));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/shippingPayment.js